module.exports = __webpack_public_path__ + "static/media/31.25b5e20f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/31.svg
// module id = 402
// module chunks = 14